import React, { Component } from "react";
import { connect } from "react-redux";

import "./GymRegistration.css";

import { callAPI } from "../../assets/Js/backendCommunication";
import { withRouter } from "react-router-dom";
import { Spinner } from "../../Components/Spinner/Spinner";

import { imageRegex } from "../../assets/Js/regex";

import projectSettings from "../../assets/Js/projectSettings";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import {
  getUserGymData,
  setUserGymData,
} from "../../assets/Js/localStorage";
import { getPlainToken } from "../../assets/Js/tokenHandler";
import { closeModel } from "../../assets/Js/closeModel";

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
  };
};

export default connect(
  mapStateToProps,
  null
)(
  withRouter(
    class GymRegistrationGymCreationForm extends Component {
      constructor() {
        super();

        let userGymData = getUserGymData();

        this.state = {
          id: (userGymData && userGymData.Id) || null,
          imageRightFormat: false,
          name: (userGymData && userGymData.Name) || "",
          tagline: (userGymData && userGymData.TagLine) || "",
          address: (userGymData && userGymData.Address) || "",
          image: (userGymData && userGymData.Image) || "",
          status: true,
        };
      }

      submitHandler = async (e) => {
        e.preventDefault();

        if (this.state.image && this.state.image.name) {
          await this.setState({
            imageRightFormat: !imageRegex.test(this.state.image.name),
          });
        }

        if (!this.state.imageRightFormat) {
          if (getPlainToken()) {
            this.updateGym();
          } else {
            this.createGym();
          }
        }
      };

      createGym = async () => {
        let url = `${projectSettings.baseUrl}/gyms/create`;
        let header = false;
        let type = "POST";
        let token = null;

        let { name, tagline, address, image, status } = this.state;
        let gymAccountId = this.props.match.params.id;

        let formData = new FormData();

        formData.append("Name", name);
        formData.append("Tagline", tagline);
        formData.append("Address", address);
        if (image) {
          formData.append("Image", image);
        }
        formData.append("Status", status);
        formData.append("UserId", gymAccountId);

        let response = "";

        if (response === "") {
          this.setState({ isLoading: true });
        }

        response = await callAPI(url, header, type, formData, token);

        if (response) {          
          this.setState({ isLoading: false });
          if (response.type === "error") {
            console.error("Error:", response);
          } else if (response.type === "success") {
            response = "";
            this.props.history.push("/login");
          }
        }
      };

      updateGym = async () => {
        let url = `${projectSettings.baseUrl}/gyms/update/${this.state.id}`;
        let header = false;
        let type = "POST";
        let token = getPlainToken();

        let { name, tagline, address, image, status } = this.state;

        let formData = new FormData();

        formData.append("name", name);
        formData.append("tagline", tagline);
        formData.append("address", address);
        if (image) {
          formData.append("image", image);
        }
        formData.append("status", status);

        let response = "";

        if (response === "") {
          this.setState({ isLoading: true });
        }

        response = await callAPI(url, header, type, formData, token);

        if (response) {
          apiResponseToast(response.status, "gymCreation");

          this.setState({ isLoading: false });
          if (response.type === "error") {
            console.error("Error:", response);
          } else if (response.type === "success") {
            let userGymData = {
              Address: this.state.address,
              Id: this.state.id,
              Image: this.state.image.name,
              Name: this.state.name,
              TagLine: this.state.tagline,
            };
            setUserGymData(JSON.stringify(userGymData));
            response = "";
            closeModel(this.props.modalId);
          }
        }
      };

      render() {
        return (
          <div>
            <form
              className="forms-sample p-3 pb-1"
              onSubmit={this.submitHandler}
            >
              <div className="formGroup">
                <div className="mr-1">
                  <label htmlFor="gymName">Gym Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="gymName"
                    value={this.state.name}
                    placeholder="Gym Name"
                    required
                    onChange={(e) => this.setState({ name: e.target.value })}
                  />
                </div>
              </div>
              <div className="formGroup">
                <div className="mr-1">
                  <label htmlFor="gymTagline">Gym Tagline</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="gymTagline"
                    value={this.state.tagline}
                    placeholder="Gym Tagline"
                    required
                    onChange={(e) => this.setState({ tagline: e.target.value })}
                  />
                </div>
              </div>
              <div className="formGroup">
                <div className="mr-1">
                  <label htmlFor="address">Address</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="address"
                    value={this.state.address}
                    placeholder="Address"
                    required
                    onChange={(e) => this.setState({ address: e.target.value })}
                  />
                </div>
              </div>
              {this.state.imageRightFormat ? (
                <p className="text-danger">
                  Supported Formats gif, jpg, jpeg, png
                </p>
              ) : null}
              <div className="formGroup ">
                <label>Gym Logo</label>
                <div className="custom-file">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="image"
                    accept="image/*"
                    onChange={(e) =>
                      this.setState({ image: e.target.files[0] })
                    }
                  />
                  <label
                    className="fileInputBtn customFieldLableForm1 custom-file-label text-secondary"
                    for="customFileLang"
                  >
                    {typeof this.state.image === "object" &&
                    this.state.image.name ? (
                      <span>{this.state.image.name}</span>
                    ) : (
                      <span>Upload Image</span>
                    )}
                  </label>
                </div>
              </div>
              <div className="mx-auto width-fit-content mt-3 mb-3">
                <button
                  className="basicBtnStyle primaryBtn"
                  disabled={this.state.isLoading}
                >
                  {this.state.isLoading ? (
                    <Spinner />
                  ) : getPlainToken() ? (
                    <span>Update</span>
                  ) : (
                    <span>Finish</span>
                  )}
                </button>
              </div>
            </form>
          </div>
        );
      }
    }
  )
);
